//封装富文本编辑器
<template>
  <div :class="{ 'border-line': border }">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor
      :style="{ height }"
      v-model="html"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
      @onChange="onChange"
    />
  </div>
</template>
<script>
import Vue from "vue";
import { Boot } from "@wangeditor/editor";
import attachmentModule from "@wangeditor/plugin-upload-attachment";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import "@wangeditor/editor/dist/css/style.css";
// import axios from "axios ";

Boot.registerModule(attachmentModule);

export default {
  components: { Editor, Toolbar },
  props: {
    //border
    border: {
      type: Boolean,
      default: false,
    },
    /* 编辑器的内容 */
    value: {
      type: String,
      default: "",
    },
    // 高度
    height: {
      type: String,
      default: () => "500px",
    },
  },
  data() {
    return {
      editor: null,
      html: "",
      toolbarConfig: {
        excludeKeys: ["fullScreen"],
        insertKeys: {
          index: 24,
          keys: ["uploadAttachment"],
        },
      },
      editorConfig: {
        placeholder: "请输入内容...",
        scroll: false,
        MENU_CONF: {
          uploadImage: {
            // 自定义上传图片 方法
            customUpload: this.uploadImg,
            // 上传接口设置文件名
            fieldName: "file",
            meta: {
              token: localStorage.getItem("token"),
            },
          },
          uploadVideo: {
            customUpload: this.uploadVideo,
            fieldName: "file",
            meta: {
              token: localStorage.getItem("token"),
            },
          },
          uploadAttachment: {
            customUpload: this.uploadFile,
            fieldName: "file",
            meta: {
              token: localStorage.getItem("token"),
            },
          },
        },
        hoverbarKeys: {
          attachment: {
            menuKeys: ["downloadAttachment"],
          },
        },
      },

      mode: "default", //default or 'simple'
    };
  },
  watch: {
    value: {
      handler(val) {
        this.html = val;
      },
      immediate: true,
    },
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onChange(editor) {
      this.$emit("input", this.html);
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    uploadImg(file, insertFn) {
      let imgData = new FormData();
      imgData.append("file", file);
      commonAxios({
        url: `/fileUpload`,
        data: imgData,
        method: "post",
        headers: {
          Authorization:  localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.success) {
          insertFn(`图片url`);
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
    uploadVideo(file, insertFn) {
      let imgData = new FormData();
      imgData.append("file", file);
      commonAxios({
        url: `/fileUpload`,
        data: imgData,
        method: "post",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.success) {
          insertFn(`视频url`);
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
    uploadFile(file, insertFn) {
      let imgData = new FormData();
      imgData.append("file", file);
      commonAxios({
        url: `/fileUpload`,
        data: imgData,
        method: "post",
        headers: {
          Authorization:  localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.success) {
          insertFn(
            `附件:${res.resultData.elementName}`,`下载url`);
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.border-line {
  border: 1px solid #d6d6d6;
}
/deep/.w-e-scroll > div:first-child {
  height: 100%;
  overflow-y: auto;
}
</style>
